<!--
 - Author : wanghongling.
 - Date   : 2020/12/23.
 - File   : abnormalTemperature.
 -->

<template>
  <layer title="体温异常人员" titleClass="01" width="326px" padding="15px 20px">
    <div class="abnormal-wrap">
      <el-carousel :interval="10000" style="width: 235px"
                   height="170px"
                   :indicator-position="list.length>1?'outside':'none'"
                   :arrow="list.length>1?'hover':'never'">
        <el-carousel-item v-for="(item, i) in list" :key="i">
      <div class="abnormal-wrap-item"  v-for="(shi, index) in item"  :key="index">
        <div class="abnormal-left">
          <el-avatar :size="50" :src="shi.signAvatar?(imgUrl+shi.signAvatar):avatar"></el-avatar>
          <div class="left-cont">
            <p class="left-cont-name">{{shi.userName}}</p>
            <p class="left-cont-desc">{{shi.teperatureTime}} <span>晨检</span></p>
          </div>
        </div>
        <div class="abnormal-right">
          {{shi.bodyTeperature}}℃
        </div>
      </div>
        </el-carousel-item>
      <div class="no-the-data" v-if="list && list.length===0">
        <div>
          <i class="iconfont icon-content-likes dzi"></i>
          <p>暂无体温异常人员</p>
        </div>
      </div>
      </el-carousel>
    </div>
  </layer>
</template>

<script>
  export default {
    name: 'abnormalTemperature',
    data () {
      return {
        departmentId: '',
        imgUrl: this.$store.getters.fileApi,
        avatar: require('../../assets/images/avatar.jpg'),
        list: []
      }
    },
    watch: {
      selectDeptId: {
        handler(cur) {
          this.departmentId = cur
          this.getAbnormalTemperatureList()
        },
        deep: true
      }
    },
    props: ['selectDeptId'],
    mounted() {
      if(this.departmentId) {
        this.getAbnormalTemperatureList()
      }
      this.temperatureWsMsg()
    },
    methods: {
      /**
       * @author wanghongling
       * @createTime 2020/12/24
       * @description websocket监听数据
       */
      temperatureWsMsg () {
        window.getTemperatureInfo = e => {
          console.log(e, 'websocket监听数据')
          this.getAbnormalTemperatureList()
        }
      },
      /**
       * @Description:获取名厨亮灶体温异常人员
       * @author wanghongling
       * @createDate 2020/12/24
       */
      getAbnormalTemperatureList() {
        this.$request.healthTemperatureExceptionTodayGet({departmentId: this.departmentId}).then(res => {
          console.log('获取名厨亮灶体温异常人员', res)
          this.list = []
          let tmpList = res
          for (let i = 0; i < tmpList.length; i += 2) {
            this.list.push(tmpList.slice(i, i + 2))
          }
        }).catch(e => {
          console.error(e)
        })
      }
    }
  }
</script>

<style lang="less">
  .abnormal-wrap{
    height: 170px;
    .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
    .el-carousel__indicators--outside button{
      background-color: #000;
      opacity: 1;
    }
    .el-carousel__indicator.is-active button{
      background-color: #0a8b9c;
    }
    .el-carousel__indicator--horizontal{
      padding: 6px 4px;
    }
    .el-carousel__arrow--left {
      left: 0;
    }
    .el-carousel__arrow--rgiht {
      right: 0;
    }
    &-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      &:last-child{
        margin-bottom: 0;
      }
      .abnormal-left{
        display: flex;
        align-items: center;
        .left-cont{
          padding-left: 10px;
          p{
            font-size: 14px;
          }
          &-name{
            color: #00fffc;
            padding-bottom: 5px;
          }
          &-desc{
            color: #849d9d;
          }
        }
      }
      .abnormal-right{
        color: #ff6060;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mingChu/abnormalTemperature.vue